import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialog, MatDialogConfig } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { BrandService } from '../../_ecomservices/brand.service';
import { BrandEditComponent } from '../brand-edit/brand-edit.component';
import { DialogService } from 'src/app/_services/dialog.service';


@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.css']
})
export class BrandsComponent implements OnInit {

  brand_img: File = null;
  brandImagePreview: string | ArrayBuffer | null = null;

  brandList: any = [];
  displayedColumns: string[] = ['BrandImage', 'BrandName', 'Action'];

  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;

  constructor(
    private titleService: Title,
    private dialogService: DialogService,
    public brandService: BrandService,
    private loading: LoadingService,
    private notificationService: NotificationService,
    private dialog: MatDialog,) {
  }

  ngOnInit() {
    this.titleService.setTitle('Brand List');
    this.onLoadBrands();
  }

  onLoadBrands() {
    var result = this.brandService.get_brands().subscribe(data => {
      console.log(data);
      this.brandList = data['brandList'];
      this.dataSource = new MatTableDataSource<any>(data['brandList']);
      this.dataSource.paginator = this.paginator;
      this.loading.spin$.next(false);
    });
  }

  applyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
  }

  onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }

  onSelectBrandImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.brand_img = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.brandImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onBrandFormSubmit(formData: any) {
    if (this.brandService.brand_form.valid) {
      this.loading.spin$.next(true);
      this.brandService.insert_brand(formData, this.brand_img).subscribe(data => {
        if (data['status']) {
          this.notificationService.success(data['message']);
          this.brandService.brand_form.reset();
          if (this.brandImagePreview) {
            this.brandImagePreview = null;
          }
          this.onLoadBrands();
          this.loading.spin$.next(false);
        }
        else {
          this.notificationService.error(data['error_message']);
          this.loading.spin$.next(false);
        }
      });
    }
  }

  onFileChange($event) { }

  onEdit(brandId) {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '0px' };
    matDialogConfig.data = { brandId: brandId }
    this.dialog.open(BrandEditComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.onLoadBrands();
    });
  }

  onDeleteBrand(brandId) {
    this.dialogService.openConfirmDialog('Are you sure want to delete this brand?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.loading.spin$.next(true);
          this.brandService.delete_brand(brandId).subscribe(data => {
            if (data['status']) {
              this.notificationService.success(data['message']);
              this.onLoadBrands();
              this.loading.spin$.next(false);
            }
            else {
              this.notificationService.error(data['message']);
              this.loading.spin$.next(false);
            }
          });
        }
      });
  }



}


